import { c as _c } from "react/compiler-runtime";
import { IcoChevronLeftBig24, IcoClose24 } from '@onefootprint/icons';
import { Dialog, IconButton } from '@onefootprint/ui';
import { useContext, useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { useStore } from 'zustand';
import { LEGACY_IDV_CONTAINER_ID } from '@/idv2/components/constants';
import { useNavigationHeaderPortalId } from '@/idv2/components/internal/gallery-portal-context';
import { type IDV2Store, StoreContext } from '@/idv2/features/idv-to-idv2';
import type { NavigationHeaderProps } from './types';
const NavigationHeader = t0 => {
  const $ = _c(63);
  const {
    leftButton,
    rightButton,
    content,
    position
  } = t0;
  const {
    t
  } = useTranslation("idv2");
  const store = useContext(StoreContext);
  const hideNavigationButtons = useStore(store, _temp);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [portalTarget, setPortalTarget] = useState(null);
  const [dialogContainer, setDialogContainer] = useState(null);
  const portalId = useNavigationHeaderPortalId();
  let t1;
  let t2;
  if ($[0] !== portalId || $[1] !== position) {
    t1 = () => {
      if (position !== "floating" && position !== "button-only") {
        setPortalTarget(document.getElementById(portalId));
      }
      setDialogContainer(document.getElementById(LEGACY_IDV_CONTAINER_ID));
    };
    t2 = [position, portalId];
    $[0] = portalId;
    $[1] = position;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useLayoutEffect(t1, t2);
  const shouldShowClose = leftButton?.variant === "close" && !hideNavigationButtons;
  const shouldShowBack = leftButton?.variant === "back" && !hideNavigationButtons;
  const staticTitle = content?.kind === "static" ? content.title : undefined;
  let t3;
  if ($[4] !== leftButton) {
    t3 = () => {
      if (leftButton?.variant !== "close") {
        return;
      }
      if (leftButton.confirmClose) {
        setShowConfirmDialog(true);
      } else {
        leftButton.onClose?.();
      }
    };
    $[4] = leftButton;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleClose = t3;
  let t4;
  if ($[6] !== leftButton || $[7] !== store) {
    t4 = () => {
      setShowConfirmDialog(false);
      if (leftButton?.variant === "close") {
        const onClose = leftButton.onClose ?? store?.getState().onClose;
        onClose?.();
      }
    };
    $[6] = leftButton;
    $[7] = store;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handleConfirmClose = t4;
  if (!shouldShowBack && !shouldShowClose && !rightButton && !staticTitle) {
    let t5;
    if ($[9] !== portalTarget) {
      t5 = portalTarget ? null : <div className="relative flex items-center py-4 h-14 w-full" />;
      $[9] = portalTarget;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    return t5;
  }
  let t5;
  if ($[11] !== handleClose || $[12] !== shouldShowClose) {
    t5 = shouldShowClose && <IconButton aria-label="Close" icon={IcoClose24} onClick={handleClose} />;
    $[11] = handleClose;
    $[12] = shouldShowClose;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== leftButton || $[15] !== shouldShowBack) {
    t6 = shouldShowBack && <IconButton aria-label="Go back" icon={IcoChevronLeftBig24} onClick={leftButton?.variant === "back" ? leftButton.onBack : undefined} />;
    $[14] = leftButton;
    $[15] = shouldShowBack;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t5 || $[18] !== t6) {
    t7 = <div className="absolute left-0">{t5}{t6}</div>;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== staticTitle) {
    t8 = staticTitle && <div className="absolute inset-0 flex items-center justify-center pointer-events-none"><span className="text-label-2 text-primary">{staticTitle}</span></div>;
    $[20] = staticTitle;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== rightButton) {
    t9 = rightButton && <IconButton aria-label={rightButton.label ?? "Action"} icon={rightButton.icon} onClick={rightButton.onClick} />;
    $[22] = rightButton;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t9) {
    t10 = <div className="absolute right-0 flex items-center gap-2">{t9}</div>;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== t10 || $[27] !== t7 || $[28] !== t8) {
    t11 = <div className="relative flex items-center py-4 h-14 w-full">{t7}{t8}{t10}</div>;
    $[26] = t10;
    $[27] = t7;
    $[28] = t8;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  const navContent = t11;
  let t12;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = () => setShowConfirmDialog(false);
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t) {
    t13 = t(_temp2);
    $[31] = t;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== t) {
    t14 = t(_temp3);
    $[33] = t;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== handleConfirmClose || $[36] !== t14) {
    t15 = {
      label: t14,
      onClick: handleConfirmClose
    };
    $[35] = handleConfirmClose;
    $[36] = t14;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== t) {
    t16 = t(_temp4);
    $[38] = t;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  let t17;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = () => setShowConfirmDialog(false);
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== t16) {
    t18 = {
      label: t16,
      onClick: t17
    };
    $[41] = t16;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== t) {
    t19 = t(_temp5);
    $[43] = t;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] !== t19) {
    t20 = <p className="text-body-2 text-secondary text-center">{t19}</p>;
    $[45] = t19;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== dialogContainer || $[48] !== showConfirmDialog || $[49] !== t13 || $[50] !== t15 || $[51] !== t18 || $[52] !== t20) {
    t21 = <Dialog open={showConfirmDialog} onClose={t12} title={t13} isConfirmation={true} size="compact" container={dialogContainer} primaryButton={t15} secondaryButton={t18}>{t20}</Dialog>;
    $[47] = dialogContainer;
    $[48] = showConfirmDialog;
    $[49] = t13;
    $[50] = t15;
    $[51] = t18;
    $[52] = t20;
    $[53] = t21;
  } else {
    t21 = $[53];
  }
  const dialog = t21;
  if (portalTarget) {
    let t22;
    if ($[54] !== navContent || $[55] !== portalTarget) {
      t22 = createPortal(navContent, portalTarget);
      $[54] = navContent;
      $[55] = portalTarget;
      $[56] = t22;
    } else {
      t22 = $[56];
    }
    let t23;
    if ($[57] !== dialog || $[58] !== t22) {
      t23 = <>{t22}{dialog}</>;
      $[57] = dialog;
      $[58] = t22;
      $[59] = t23;
    } else {
      t23 = $[59];
    }
    return t23;
  }
  let t22;
  if ($[60] !== dialog || $[61] !== navContent) {
    t22 = <>{navContent}{dialog}</>;
    $[60] = dialog;
    $[61] = navContent;
    $[62] = t22;
  } else {
    t22 = $[62];
  }
  return t22;
};
export default NavigationHeader;
function _temp(state) {
  return state.hideNavigationButtons;
}
function _temp2($) {
  return $.confirmationDialog.title;
}
function _temp3($_0) {
  return $_0.confirmationDialog.confirm;
}
function _temp4($_1) {
  return $_1.confirmationDialog.cancel;
}
function _temp5($_2) {
  return $_2.confirmationDialog.description;
}